import React from 'react'

/**
 * Card — the white frosted card used throughout the site.
 * Props:
 *   label    — small uppercase eyebrow text
 *   title    — h2 heading
 *   children — card body content
 *   style    — optional extra inline styles
 */
export default function Card({ label, title, children, style }) {
  return (
    <div className="card" style={style}>
      {label && <p className="card-label">{label}</p>}
      {title && <h2>{title}</h2>}
      {children}
    </div>
  )
}
